<template>
  <div class="w-full flex flex-col md:flex-row">
    <div class="panel mb-8 md:mb-0 md:mr-6">
      <h2 class="uppercase font-semibold text-sm mb-5">'CTA' for Sales</h2>
      <div class="flex flex-col mb-6">
        <label class="text-xs uppercase mb-2">Contact Number:</label>
        <input v-model="cta.sales.number" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>

      <div class="flex flex-col mb-6">
        <label class="text-xs uppercase mb-2">Email Address:</label>
        <input v-model="cta.sales.email" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>

      <div class="flex flex-col">
        <label class="text-xs uppercase mb-2">Website:</label>
        <input v-model="cta.sales.website" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>
    </div>

    <div class="panel">
      <h2 class="uppercase font-semibold text-sm mb-5">'CTA' for Lettings</h2>
      <div class="flex flex-col mb-6">
        <label class="text-xs uppercase mb-2">Contact Number:</label>
        <input v-model="cta.lettings.number" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>

      <div class="flex flex-col mb-6">
        <label class="text-xs uppercase mb-2">Email Address:</label>
        <input v-model="cta.lettings.email" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>

      <div class="flex flex-col">
        <label class="text-xs uppercase mb-2">Website:</label>
        <input v-model="cta.lettings.website" readonly class="bg-white outline-none rounded p-2 shadow border" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel {
  @apply w-full p-6 rounded border bg-blue-lightest
}
</style>

<script>
export default {
  name: 'CallToAction',

  props: ['value'],

  computed: {
    cta: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
